import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const subscopeHierarchyNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.subscope_hierarchy_breadcrumb, {
      displayName: 'Dashboards',
      icon: SolIcon.dashboard,
    }),
    SolNavbarItem.of(PrototypeRouteId.subscope_hierarchy_scope, {
      displayName: 'Scope',
      icon: SolIcon.scope,
      showChildrenAsTabs: true,
      children: [
        SolNavbarItem.of(PrototypeRouteId.subscope_hierarchy_scope_overview, { displayName: 'Overview' }),
        SolNavbarItem.of(PrototypeRouteId.subscope_hierarchy_scope_seeds, { displayName: 'Seeds' }),
        SolNavbarItem.of(PrototypeRouteId.subscope_hierarchy_scope_subscopes, { displayName: 'Subscopes' }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
